import { useEffect } from 'react'

export function useScrollReveal() {
  useEffect(() => {
    // Viewport'ta görünen elemanları hemen görünür yap
    const revealInView = (el: Element) => {
      const rect = el.getBoundingClientRect()
      if (rect.top < window.innerHeight + 100) {
        el.classList.add('visible')
      }
    }

    // Scroll'da görünür olan elemanlar için IntersectionObserver
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('visible')
            io.unobserve(e.target)
          }
        })
      },
      { threshold: 0.05, rootMargin: '0px 0px 80px 0px' }
    )

    const setup = () => {
      document.querySelectorAll('.reveal').forEach((el) => {
        revealInView(el)
        if (!el.classList.contains('visible')) {
          io.observe(el)
        }
      })
    }

    // İlk kurulum
    setup()

    // Lazy-loaded route bileşenler DOM'a eklenince tetikle
    const mo = new MutationObserver(() => setup())
    mo.observe(document.body, { childList: true, subtree: true })

    return () => {
      io.disconnect()
      mo.disconnect()
    }
  }, [])
}
